import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { coaches } from "~/../drizzle/schema";
import { count, isNotNull } from "drizzle-orm";
import { getDBWithInit } from "~/lib/db";
import { and, gte } from "drizzle-orm";

const getNewCoachCount = async () => {
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

  const [result] = await (
    await getDBWithInit()
  )
    .select({ count: count() })
    .from(coaches)
    .where(
      and(
        gte(coaches.createdAt, thirtyDaysAgo),
        isNotNull(coaches.ghlLocationId),
      ),
    );

  return result.count;
};

export const Route = createFileRoute("/embed/new-coaches-30d/")({
  loader: async () => {
    const newCoachCount = await getNewCoachCount();
    return { newCoachCount };
  },
  component: NewCoaches30dPage,
});

function NewCoaches30dPage() {
  const { newCoachCount } = Route.useLoaderData();

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-white">
      <div className="font-heading text-[min(40vw,40vh)] tabular-nums">
        {newCoachCount}
      </div>
    </div>
  );
}
